(function () {
  function translateRemove(scope) {
    if (!scope) return;
    // alle DIVs durchsuchen, die genau "Remove" enthalten
    const nodes = scope.querySelectorAll('div[title^="Remove"], div[aria-label^="Remove"]');
    nodes.forEach(el => {
      if (el.textContent.trim().toLowerCase() === 'remove') {
        el.textContent = 'Entfernen';
        el.setAttribute('title', el.getAttribute('title').replace(/^Remove/, 'Entfernen'));
        if (el.hasAttribute('aria-label')) {
          el.setAttribute('aria-label', el.getAttribute('aria-label').replace(/^Remove/, 'Entfernen'));
        }
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    translateRemove(document.body);

    // MutationObserver, falls Uploadly-Widget später lädt
    const obs = new MutationObserver(() => translateRemove(document.body));
    obs.observe(document.body, { childList: true, subtree: true });
  });
})();
